function isCorrect(hasMatch, flipResult) {
  if (hasMatch === undefined) {
    return;
  }
  return flipResult ? !hasMatch : hasMatch;
}

export default isCorrect;
